import http from "@services/httpService"

class DashboardService {
  /**
   * Lấy dữ liệu dashboard tiến độ phê duyệt hợp đồng
   * @param params 
   * - StaffId
   * - FromDate
   * - ToDate
   * - AgencyMasterId
   * - ProjectId
   * @returns 
   */
  public async getApprovedContract(params: any): Promise<any> {
    const res = await http.get("api/services/app/Dashboard/GetApprovedContract", {
      params,
    })
    return res.data.result
  }

  /**
   * Tiến độ thanh toán ( tổng và hiện tại và trước đó)
   * @param params 
   * - FromDate
   * - ToDate
   * - PreviousFromDate
   * - PreviousToDate
   * - AgencyMasterId
   * - ProjectId
   * - StaffId
   * @returns 
   */
    public async getSummaryDashboardPayment(params: any): Promise<any> {
      const res = await http.get("api/services/app/Dashboard/GetSummaryDashboardPayment", {
        params,
      })
      return res.data.result
    }

    /**
     * Lấy dữ liệu dashboard Tổng tiền thu
     * @param params 
     * - FromDate
    * - ToDate
    * - PreviousFromDate
    * - PreviousToDate
    * - ProjectId
     * @returns 
     */
    public async getContractToReceipt(params: any): Promise<any> {
        const res = await http.get("api/services/app/Dashboard/GetContractToReceipt", {
            params,
        })
        return res.data.result
    }

    /**
     * Lấy dữ liệu dashboard Tổng tiền thu theo hợp đồng
     * @param params 
     * - FromDate
     * - ToDate
     * - PreviousFromDate
     * - PreviousToDate
     * - ProjectId
     * @returns 
     */

    public async GetContractDebtLedger(params: any): Promise<any> {
        const res = await http.get("api/services/app/Dashboard/GetContractDebtLedger", {
            params,
        })
        return res.data.result
    }

    /**
     * Lấy dữ liệu Dashboard khách hàng tổng quan
     * @param params 
     * - FromDate
     * - ToDate
     * - PreviousFromDate
     * - PreviousToDate
     * @returns 
     */

    public async GetSummaryCustomer(params: any): Promise<any> {
        const res = await http.get("api/services/app/Dashboard/GetSummaryCustomer", {
            params,
        })
        return res.data.result
    }

    /**
     * Lấy dữ liệu Dashboard Khách hàng tăng trưởng theo ngày
     * @param params 
     * - FromDate
     * - ToDate
     * @returns 
     */

    public async GetSummaryByDate(params: any): Promise<any> {
        const res = await http.get("api/services/app/Dashboard/GetSummaryByDate", {
            params,
        })
        return res.data.result
    }
    /**
     * Lấy dữ liệu Dashboard Khách hàng mua theo nhóm loại sản phẩm
     * @param params 
     * - FromDate
     * - ToDate
     * - ProjectId
     * - CartId
     * @returns 
     */
    public async getSummaryCustomerGroupByProductType(params: any): Promise<any> {
        const res = await http.get("api/services/app/Dashboard/GetSummaryCustomerGroupByProductType", {
            params,
        })
        return res.data.result
    }

    /**
     * Lấy dữ liệu Dashboard Lấy tiền thu theo tháng
     * @param params 
     * - Year
     * @returns
     */
    public async getSummaryMonthlyTotalPaymentWithYear(params: any): Promise<any> {
        const res = await http.get("api/services/app/Dashboard/GetSummaryMonthlyTotalPaymentWithYear", {
            params,
        })
        return res.data.result
    }

    /**
     * Lấy dữ liệu Dashboard Lấy doanh số theo tháng
     * @param params 
     * - Year
     * @returns
     */
    public async getSummaryMonthlyTotalRevenueWithYear(params: any): Promise<any> {
        const res = await http.get("api/services/app/Dashboard/GetSummaryMonthlyTotalRevenueWithYear", {
            params,
        })
        return res.data.result
    }

    /**
     * Lấy dữ liệu Dashboard Khách hàng trong sàn
     * @param params 
     * - CartId
     * @returns
     */
    public async getAgencyMasterCustomerCount(params: any): Promise<any> {
        const res = await http.get("api/services/app/Dashboard/GetAgencyMasterCustomerCount", {
            params,
        })
        return res.data.result
    }

    /**
     * Lấy dữ liệu Dashboard Lấy thông số BK và hợp đồng theo sàn
     * @param params 
     * - AgencyCountType
     * - CartId
     * - FromDate
     * - ToDate
     * @returns
     */
    public async getSummaryAgencyMasterPerformance(params: any): Promise<any> {
        const res = await http.get("api/services/app/Dashboard/GetSummaryAgencyMasterPerformance", {
            params,
        })
        return res.data.result
    }


    /**
     * Lấy dữ liệu Dashboard Tổng quan trạng thái của sản phẩm
     * @param params 
     * - AgencyCountType
     * - CartId
     * - FromDate
     * - ToDate
     * @returns
     */
    public async getSummaryUnitStatus(params: any): Promise<any> {
        const res = await http.get("api/services/app/Dashboard/GetSummaryUnitStatus", {
            params,
        })
        return res.data.result
    }
    /**
     * Lấy dữ liệu Dashboard Lấy thông số BK và hợp đồng dự án
     * @param params 
     * - AgencyCountType
     * - CartId
     * - FromDate
     * - ToDate
     * @returns
     */
    public async getSummaryProjectPerformance(params: any): Promise<any> {
        const res = await http.get("api/services/app/Dashboard/GetSummaryProjectPerformance", {
            params,
        })
        return res.data.result
    }
    /**
     * Lấy dữ liệu Dashboard Tổng quan trạng thái của sản phẩm theo dự án
     * @param params 
     * - AgencyCountType
     * - CartId
     * - FromDate
     * - ToDate
     * @returns
     */
    public async getSummaryUnitStatusWithProject(params: any): Promise<any> {
        const res = await http.get("api/services/app/Dashboard/GetSummaryUnitStatusWithProject", {
            params,
        })
        return res.data.result
    }

}

export default new DashboardService()